export default __webpack_public_path__ + "static/media/logo-hygiap-white.5683ab1c.svg";